import styled from 'styled-components';

const Body = styled.div`
`;

export const Styled = {
  Body,
};
